var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownwardsArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30317",
    "data-name": "Group 30317",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7205",
    "data-name": "Ellipse 7205",
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "#ea1e63"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-up-svgrepo-com",
    d: "M12,19V5m0,14L6,13m6,6,6-6",
    transform: "translate(7.5 8.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownwardsArrow);
export default __webpack_public_path__ + "static/media/downwards-arrow.40707b7c4a24cf91b4241bdf05f61aa1.svg";
export { ForwardRef as ReactComponent };